import { leadFormService } from '../../helpers/services/leadForm.service'
import i18n from '@/i18n'
import { sharedHelper } from '@/utils'

export const state = {
  list: [],
  pagination: {},
  details: null,
  submissions: [],
  submissionPagination: {},
  schema: { field_types: [], mapped_keys: [], sources: [] },
  lastError: null,
}

export const LEAD_FORM_MODULE = 'leadForm'

export const GET_ALL_LEAD_FORMS = 'getAllLeadForms'
export const GET_LEAD_FORM = 'getLeadForm'
export const CREATE_LEAD_FORM = 'createLeadForm'
export const UPDATE_LEAD_FORM = 'updateLeadForm'
export const DELETE_LEAD_FORM = 'deleteLeadForm'
export const ROTATE_LEAD_FORM_TOKEN = 'rotateLeadFormToken'
export const GET_LEAD_FORM_SUBMISSIONS = 'getLeadFormSubmissions'
export const GET_LEAD_FORM_SCHEMA = 'getLeadFormSchema'

const LIST_SUCCESS = 'listSuccess'
const DETAIL_SUCCESS = 'detailSuccess'
const SUBMISSIONS_SUCCESS = 'submissionsSuccess'
const SCHEMA_SUCCESS = 'schemaSuccess'
const SET_ERROR = 'setError'
const CLEAR_ERROR = 'clearError'

/**
 * Errors are stored as well as alerted so the form page can put the message
 * under the field that caused it, which is the house style — see crmForm.mixin.
 */
function fail(commit, e) {
  commit(SET_ERROR, e?.response?.data || null)
  sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
}

export const actions = {
  [GET_ALL_LEAD_FORMS]({ commit }, payload) {
    return leadFormService.getAll(payload?.filter).then((r) => {
      commit(LIST_SUCCESS, r)
      return r
    }).catch((e) => fail(commit, e))
  },
  [GET_LEAD_FORM]({ commit }, { uuid }) {
    return leadFormService.getOne(uuid).then((r) => {
      commit(DETAIL_SUCCESS, r)
      return r
    }).catch((e) => fail(commit, e))
  },
  [GET_LEAD_FORM_SCHEMA]({ commit }) {
    return leadFormService.schema().then((r) => {
      commit(SCHEMA_SUCCESS, r)
      return r
    }).catch((e) => fail(commit, e))
  },
  [CREATE_LEAD_FORM]({ commit, dispatch }, { data }) {
    commit(CLEAR_ERROR)
    return leadFormService.create(data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.createX', ['Form']))
      dispatch(GET_ALL_LEAD_FORMS)
      return r
    }).catch((e) => fail(commit, e))
  },
  [UPDATE_LEAD_FORM]({ commit, dispatch }, { uuid, data }) {
    commit(CLEAR_ERROR)
    return leadFormService.update(uuid, data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.updateX', ['Form']))
      dispatch(GET_ALL_LEAD_FORMS)
      return r
    }).catch((e) => fail(commit, e))
  },
  [DELETE_LEAD_FORM]({ commit, dispatch }, { uuid }) {
    return leadFormService.remove(uuid).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.deleteX', ['Form']))
      dispatch(GET_ALL_LEAD_FORMS)
      return r
    }).catch((e) => fail(commit, e))
  },
  [ROTATE_LEAD_FORM_TOKEN]({ commit }, { uuid }) {
    return leadFormService.rotateToken(uuid).then((r) => {
      commit(DETAIL_SUCCESS, r)
      sharedHelper.alertSuccessMessage(i18n.t('leadForm.tokenRotated'))
      return r
    }).catch((e) => fail(commit, e))
  },
  [GET_LEAD_FORM_SUBMISSIONS]({ commit }, { uuid, params }) {
    return leadFormService.submissions(uuid, params).then((r) => {
      commit(SUBMISSIONS_SUCCESS, r)
      return r
    }).catch((e) => fail(commit, e))
  },
}

export const mutations = {
  [LIST_SUCCESS](state, r) {
    state.list = r?.data || []
    state.pagination = r?.pagination || {}
  },
  [DETAIL_SUCCESS](state, r) { state.details = r?.data || null },
  [SUBMISSIONS_SUCCESS](state, r) {
    state.submissions = r?.data || []
    state.submissionPagination = r?.pagination || {}
  },
  [SCHEMA_SUCCESS](state, r) {
    state.schema = r?.data || { field_types: [], mapped_keys: [], sources: [] }
  },
  [SET_ERROR](state, error) { state.lastError = error || null },
  [CLEAR_ERROR](state) { state.lastError = null },
}
